module.exports = __webpack_public_path__ + "img/video-embed.36b7519d.jpg";